import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { getHost } from 'lib/commonLib';

import SelectLang from 'components/molecules/SelectLang';
import SelectInfo from 'components/molecules/SelectInfo';

import MainLogo from 'images/common/logo/logo_white.png';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    minHeight: 50,
    background: theme.palette.background.header,
    '&.tablet': { flexDirection: 'column' },
  },
  tabButtonWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  button: {
    minWidth: 40,
    color: 'white',
    borderRadius: '3px',
    fontSize: theme.palette.primary.defaultTextSize,
    margin: '0.5em',
    '&:hover': { color: theme.palette.primary.mainColor },
  },
  logoButton: { margin: '0' },
  img: { width: '120px' },
  info: { marginLeft: 0 },
}));

const Header = React.memo(({ history, user, onLogout }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const tablet = useMediaQuery('(max-width: 768px)');

  function goMain() {
    history.push('/');
  }

  /**
   * 링크
   */
  function goMobon(url) {
    window.open(url);
  }

  return (
    <header className={clsx('mb-Header', classes.header, { tablet })}>
      <div>
        <Button onClick={goMain} className={classes.logoButton}>
          <img className={classes.img} src={MainLogo} alt="mainLogo" />
        </Button>
      </div>
      <Grid item className={classes.tabButtonWrap}>
        <Button
          className={classes.button}
          onClick={() => goMobon(getHost() + '/main/m2/')}
        >
          {t('모비온')}
        </Button>
        <Button
          className={classes.button}
          onClick={() => goMobon('https://mobsense.mobon.net/')}
        >
          {t('모비센스')}
        </Button>
        <Button
          className={classes.button}
          onClick={() => goMobon('https://mobtrend.net/')}
        >
          {t('모비트렌드')}
        </Button>
        <Button
          className={classes.button}
          onClick={() => goMobon(getHost() + '/ad/manage_member.html')}
        >
          {t('(구)최고관리자')}
        </Button>
        <SelectLang />
        {user ? (
          <SelectInfo className={classes.info} onLogout={onLogout} />
        ) : (
          // <div className="right">
          //   <div>{user.username}</div>
          // </div>
          <div className="right">
            <Link to="/login">
              <Button variant="contained" color="primary">
                로그인
              </Button>
            </Link>
          </div>
        )}
      </Grid>
    </header>
  );
});

export default withRouter(Header);
